import React, { Component } from "react";
import { AppContext } from "../../data/ContextProvider";

import { getContentPage } from "../../data/api";
import { CONTENT_DATENSCHUTZ} from "../../data/constants";
import { bodyForLang } from "../../lib/lib";
import t from "../../helpers/t9n";

class Privacy extends Component {

  constructor(props) {
    super(props);
    this.state = {
      headline: "",
      body: "",
      loading: true
    }
  }

  async componentDidMount() {

    let headline = ""
    let body = ""

    const page = await getContentPage(CONTENT_DATENSCHUTZ, this.context.getProjectData().id, this.context.getProjectData().app_id)

    page.text.forEach(text => {
      if (text.key === 'p24_header_content_headline') {
        headline = text
      }
      if (text.key === 'p24_upper_content_text') {
        body = text
      }
    })

    this.setState({
      headline: headline,
      body: body,
      loading: false
    })
  }

  render() {
    if (this.loading) {
      return t("global.loading")
    }

    return (
      <>
        <div className={"content privacy tos"}>
          <h1>{bodyForLang(this.state.headline, window.currentLang)}</h1>

          <p
            dangerouslySetInnerHTML={{
              __html: bodyForLang(this.state.body, window.currentLang)
            }}>
          </p>

        </div>
      </>
    )
  }
}

Privacy.contextType = AppContext
export default Privacy;
